module.exports = __webpack_public_path__ + "static/media/background.1b04621d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cities/baltimore/background.jpg
// module id = 906
// module chunks = 27